import { render, staticRenderFns } from "./Spei.vue?vue&type=template&id=a06f9568&scoped=true"
import script from "./Spei.vue?vue&type=script&lang=js"
export * from "./Spei.vue?vue&type=script&lang=js"
import style0 from "./Spei.vue?vue&type=style&index=0&id=a06f9568&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06f9568",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a06f9568')) {
      api.createRecord('a06f9568', component.options)
    } else {
      api.reload('a06f9568', component.options)
    }
    module.hot.accept("./Spei.vue?vue&type=template&id=a06f9568&scoped=true", function () {
      api.rerender('a06f9568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/openpay/Spei.vue"
export default component.exports